export interface WicketApplication {
  id: number;
  label_pl: string;
  code: string;
}
